// extracted by mini-css-extract-plugin
export default {"card":"d0-z","carouselContainer":"e0-z","carouselContent":"f0-z"};